import { makeStyles } from '@material-ui/core/styles';

export const useFormFieldStyles = makeStyles(theme => ({
  formField: {
    flexGrow: 1
  }
}));
